// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import { Utils } from './components/mixins/utils'

Vue.config.productionTip = false

window.axios = axios.create({
	baseURL: process.env.ENDPOINT,
	params : { },
});

window.axios.interceptors.request.use((config) => {
	let form_data = new FormData();

	for ( var key in config.data ) {
		let val;
		if(key != 'file' && typeof config.data[key] == 'object') {
			val = JSON.stringify(config.data[key])
		} else {
			val = config.data[key];
		}
		form_data.append(key,  val);
	}

	config.data = form_data;
	return config;
});

Vue.mixin(Utils);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js